import React, { Fragment } from 'react'
import { withRouter, Link } from 'react-router-dom'
import Sidebar from 'react-sidebar'
import { Button, Layout, Avatar, Icon, Badge } from 'antd'
import Routers from '../router'
import MenuSidebar from '../MenuSidebar'
import './style.scss'
import { Config } from '../../config'
import { AuthService } from '../../services'
import {
  UserOutlined,
  MenuOutlined,
  CloseOutlined,
  LogoutOutlined,
  CalendarFilled,
  FileFilled,
  StarFilled,
} from '@ant-design/icons'
import NotificationCount from '../../components/NotificationCount'
import { inject, observer } from 'mobx-react'
const { Header, Content } = Layout
const mql = window.matchMedia(`(min-width: 800px)`)

@inject('informStore')
@observer
class NNSidebar extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      sidebarDocked: mql.matches,
      sidebarOpen: false,
      open: false,
      isLoggedIn: AuthService.isLoggedIn(),
      user: AuthService.getUser(),
      token: AuthService.getToken(),
      menuItems: Config.sidebarItems,
    }

    this.mediaQueryChanged = this.mediaQueryChanged.bind(this)
    this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this)
    this.checkHideSidebar = this.checkHideSidebar.bind(this)
  }

  componentWillMount() {
    mql.addListener(this.mediaQueryChanged)
  }

  componentDidMount() {
    const w = window.innerWidth
  }

  componentWillUnmount() {
    mql.removeListener(this.mediaQueryChanged)
  }

  onSetSidebarOpen(open) {
    this.setState({ sidebarOpen: open })
    this.checkHideSidebar()
  }

  mediaQueryChanged() {
    this.setState({ sidebarDocked: mql.matches, sidebarOpen: false })
  }

  checkHideSidebar() {
    const w = window.innerWidth
    console.log('checkside', w)
    if (w < 800 && this.state.sidebarOpen === true) {
      this.setState({
        sidebarOpen: false,
      })
    }
  }

  onClickHandle = () => {
    console.log('click')
    this.setState({ sidebarOpen: false })
  }

  toggle() {
    let v = !this.state.sidebarOpen
    this.setState({
      sidebarOpen: v,
    })
  }

  doLogout() {
    AuthService.logout()
    this.props.history.push('login')
  }
   go2myevent = () => {
    this.props.history.push('myevent')
  }
   go2myjob = () => {
    this.props.history.push('myjob')
  }

  render() {
    const PAGE_TITLE = () =>
      AuthService.isLoggedIn() ? (
        <React.Fragment>
          {AuthService.getUser() ? (
            <React.Fragment>
              <h1 className="header-title">
                {/* <NotificationCount interval={60} />{' '} */}
                {/* {this.props.informStore.countNewInform > 0 ? (
                  <React.Fragment>
                    ใบแจ้งซ่อมใหม่{' '}
                    <Badge count={this.props.informStore.countNewInform} />
                  </React.Fragment>
                ) : null}{' '}
                {this.props.informStore.count4task > 0 ? (
                  <React.Fragment>
                    รอจัดคิว <Badge count={this.props.informStore.count4task} />
                  </React.Fragment>
                ) : null}{' '} */}
                <Button
                  type="link"
                  style={{ color: '#ffffff', cursor: 'pointer' }}
                  onClick={this.go2myevent}
                  icon={<CalendarFilled/>}
                >
                  ปฎิทินงานของฉัน
                </Button>
                <Button
                  type="link"
                  style={{ color: '#ffffff', cursor: 'pointer' }}
                  onClick={this.go2myjob}
                  icon={<StarFilled/>}
                >
                  งานของฉัน
                </Button>
              </h1>
            </React.Fragment>
          ) : null}
        </React.Fragment>
      ) : null

    return (
      <Fragment>
        <Layout>
          <Sidebar
            sidebar={
              <div>
                <div className="wcu-logo">
                  {/* <img
                    alt={Config.app.name.toUpperCase()}
                    src="logo512.png"
                    style={{ width: '100%' }}
                  /> */}
                  {Config.app.name.toUpperCase()}
                </div>
                {AuthService.getUser() ? (
                  <div className="wcu-profile-detail" align="center">
                    <Avatar icon={<UserOutlined />} size={50} />
                    <div>
                      {AuthService.getUser() ? AuthService.getUser().email : ''}
                    </div>
                  </div>
                ) : (
                  ''
                )}

                <MenuSidebar onClickHandle={() => this.onClickHandle} />
              </div>
            }
            open={this.state.sidebarOpen}
            docked={this.state.sidebarDocked}
            onSetOpen={this.onSetSidebarOpen}
            styles={{
              root: {
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                overflow: 'hidden',
              },
              sidebar: {
                zIndex: 100,
                width: 250,
                position: 'absolute',
                top: 0,
                bottom: 0,
                transition: 'transform .3s ease-out',
                WebkitTransition: '-webkit-transform .3s ease-out',
                willChange: 'transform',
                overflowY: 'auto',
                backgroundColor: '#ffffff',
              },
              content: {
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 15,
                overflowY: 'auto',
                WebkitOverflowScrolling: 'touch',
                transition: 'left .3s ease-out, right .3s ease-out',
              },
              overlay: {
                zIndex: 1,
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                opacity: 0,
                visibility: 'hidden',
                transition: 'opacity .3s ease-out, visibility .3s ease-out',
                backgroundColor: 'rgba(0,0,0,.3)',
              },
              dragHandle: {
                zIndex: 1,
                position: 'fixed',
                top: 0,
                bottom: 0,
              },
            }}
          >
            {!this.state.sidebarDocked && !this.state.sidebarOpen ? (
              <Button
                type="default"
                onClick={() => this.toggle()}
                icon={<MenuOutlined />}
                style={{
                  position: 'fixed',
                  top: 2,
                  right: 7,
                  zIndex: 100,
                  boxShadow: '2px 2px 2px 2px #282c34',
                }}
              ></Button>
            ) : null}
            {!this.state.sidebarDocked && this.state.sidebarOpen ? (
              <Button
                type="default"
                onClick={() => this.toggle()}
                icon={<CloseOutlined />}
                style={{
                  position: 'fixed',
                  top: 2,
                  right: 7,
                  zIndex: 100,
                  boxShadow: '2px 2px 2px 2px #282c34',
                }}
              ></Button>
            ) : null}
            <Layout>
              <Header>{PAGE_TITLE() ? PAGE_TITLE() : null} </Header>
              <Content
                style={{
                  padding: 5,
                  marginBottom: 5,
                }}
              >
                <Routers />
              </Content>
            </Layout>
          </Sidebar>
        </Layout>
      </Fragment>
    )
  }
}

export default withRouter(NNSidebar)
